import { put, takeLatest } from 'redux-saga/effects'

import { NotificationManager } from '@/components/Notification'
import { customerServiceCaseService } from '@/services'
import {
  createServiceCase,
  createServiceCaseError,
  createServiceCaseSuccess,
} from '@/store/slices/serviceCaseSlice'

function* createServiceCaseSaga({ payload }) {
  try {
    const { data } = yield customerServiceCaseService.createServiceCase(payload)

    yield put(createServiceCaseSuccess(data))

    NotificationManager.success({
      message: 'notification.success.submitRequestService',
    })
  } catch (error) {
    console.error('Create service case error:', error)
    yield put(createServiceCaseError())
    NotificationManager.error({
      message: 'notification.error.submitRequestService',
    })
  }
}

export default function* serviceCaseSaga() {
  yield takeLatest(createServiceCase.type.toString(), createServiceCaseSaga)
}
